import SearchPartDetailsStock from '@/components/SearchParts/SearchPartDetails/SearchPartDetailsStock';
import { DefaultRouteTabs } from '@/components/_common';
import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { PageProps } from '@/types/PageProps';
import { Divider } from 'antd';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';

export default function SearchPartStockPage({ route }: PageProps) {
  const { partId } = useRouteMatch<{ partId: string }>().params;

  const basePath = `/app/searchParts/${partId}`;

  return (
    <DefaultRouteTabs
      route={route.parent}
      permissions={route.permissions}
      baseKey={partId}
      basePath={basePath}
    >
      <Helmet title={useIntl().formatMessage({ id: route.name })} />

      <SearchPartDetailsStock stockId={Number(partId)} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/searchParts" />
      </SpaceForButton>
    </DefaultRouteTabs>
  );
}
